@if (isSharingEnabled) {
<button
  id="bulk-share-action"
  mat-icon-button
  [disabled]="disabled"
  (click)="openBulkShareModal()"
  [matTooltip]="tooltip"
  [matTooltipPosition]="tooltipPosition"
>
  <mat-icon class="material-icons-outlined">share</mat-icon>
</button>
}
